import { initialState } from "./State";
import { StandardRates } from "us.collection.admin/constants/Actions";

const {
  INIT_GET_STANDARD_RATES,
  INIT_GET_STANDARD_RATES_SUCCESS,
  INIT_GET_STANDARD_RATES_FAILED,
  HANDLE_STANDARD_RATES_DRAWER,

  ADD_STANDARD_RATE,
  ADD_STANDARD_RATE_SUCCESS,
  ADD_STANDARD_RATE_FAILED,

  EDIT_STANDARD_RATE,
  EDIT_STANDARD_RATE_SUCCESS,
  EDIT_STANDARD_RATE_FAILED,

  DELETE_STANDARD_RATE,
} = StandardRates;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case INIT_GET_STANDARD_RATES:
      return Object.assign({}, state, {
        rates: {
          isLoading: true,
          data: [],
        },
        ratesHistory: {
          isLoading: true,
          data: [],
        },
      });
    case INIT_GET_STANDARD_RATES_SUCCESS:
      const { standardRates, standardRatesHistory } = payload.data ?? {};
      return Object.assign({}, state, {
        rates: {
          isLoading: false,
          data: standardRates,
        },
        ratesHistory: {
          isLoading: false,
          data: standardRatesHistory,
        },
        isStandardRateDeleting: false,
      });
    case INIT_GET_STANDARD_RATES_FAILED:
      return Object.assign({}, state, {
        rates: {
          ...state.rates,
          isLoading: false,
        },
        ratesHistory: {
          ...state.ratesHistory,
          isLoading: false,
        },
        isStandardRateDeleting: false,
      });
    case HANDLE_STANDARD_RATES_DRAWER:
      return Object.assign({}, state, {
        drawerInfo: {
          ...state.drawerInfo,
          ...payload.data,
          visible: !state.drawerInfo.visible,
        },
      });
    case ADD_STANDARD_RATE:
      return Object.assign({}, state, {
        isStandardRateSaving: true,
      });
    case ADD_STANDARD_RATE_SUCCESS:
      return Object.assign({}, state, {
        isStandardRateSaving: false,
      });
    case ADD_STANDARD_RATE_FAILED:
      return Object.assign({}, state, {
        isStandardRateSaving: false,
      });

    case EDIT_STANDARD_RATE:
      return Object.assign({}, state, {
        isStandardRateSaving: true,
      });
    case EDIT_STANDARD_RATE_SUCCESS:
      return Object.assign({}, state, {
        isStandardRateSaving: false,
      });
    case EDIT_STANDARD_RATE_FAILED:
      return Object.assign({}, state, {
        isStandardRateSaving: false,
      });
      
    case DELETE_STANDARD_RATE:
      return Object.assign({}, state, {
        isStandardRateDeleting: true,
      });
    default:
      return state;
  }
};
